import React from 'react'
import PropTypes from 'prop-types'
import { classNames as cn } from 'helpers'
import './CheckboxToggle.scss'
export default function CheckboxToggle(props) {
  return (
    <div
      className={cn({
        checkboxToggle: true,
        'checkboxToggle--disabled': props.disabled,
        ['checkboxToggle--' + props.mode]: props.mode,
        'checkboxToggle--bold': props.bold,
      })}
      onClick={() => !props.disabled && props.onChange(!props.checked)}
    >
      {props.left && (
        <div
          className={cn({
            checkboxToggle__label: true,
            'checkboxToggle__label--unselected': props.checked && props.status,
            [`checkboxToggle__label--${props.labelColor}`]: props.labelColor,
          })}
        >
          {props.left}
        </div>
      )}

      <span
        className={cn({
          checkboxToggle__toggle: true,
          'checkboxToggle__toggle--checked': props.checked,
        })}
      />

      {props.right && (
        <div
          className={cn({
            checkboxToggle__label: true,
            'checkboxToggle__label--unselected': !props.checked && props.status,
            [`checkboxToggle__label--${props.labelColor}`]: props.labelColor,
          })}
        >
          {props.right}
        </div>
      )}
    </div>
  )
}
CheckboxToggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  left: PropTypes.string,
  right: PropTypes.string,
  disabled: PropTypes.bool,
  mode: PropTypes.oneOf(['inline']),
  bold: PropTypes.bool,
  labelColor: PropTypes.string,
}
